import { css } from '@emotion/react';
import { alpha } from '@mui/material/styles';

const thumbColor = theme => alpha(theme.palette.text.primary, 0.2);

export const hoverScrollbarVisible = theme => css`
  --scrollbar-thumb: ${thumbColor(theme)};
  transition: --scrollbar-thumb 0.2s ease-out;
`;

// Thin themed native scrollbar that mouse users only see while hovering, pressing or focusing the element
const hoverScrollbar = theme => css`
  ${hoverScrollbarVisible(theme)}

  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) transparent;

  @supports not (scrollbar-color: auto) {
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: var(--scrollbar-thumb);
    }
  }

  @media (hover: hover) and (pointer: fine) {
    &:not(:hover):not(:active):not(:focus-within) {
      --scrollbar-thumb: transparent;
      transition: --scrollbar-thumb 0.4s ease-in 0.3s;
    }
  }
`;

export default hoverScrollbar;
